import { render } from "./SetAuthorize.vue?vue&type=template&id=4172fa59&scoped=true"
import script from "./SetAuthorize.vue?vue&type=script&lang=js"
export * from "./SetAuthorize.vue?vue&type=script&lang=js"

import "./SetAuthorize.vue?vue&type=style&index=0&id=4172fa59&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4172fa59"]])

export default __exports__